module.exports = __webpack_public_path__ + "img/undraw_develop_app_re_bi4i.344e3f0f.svg";